// extracted by mini-css-extract-plugin
export default {"picker":"TvTargetPicker_picker__u2uKi","chips":"TvTargetPicker_chips__CeUI6","chip":"TvTargetPicker_chip__Cgesp","note":"TvTargetPicker_note__zpuT3"};